// extracted by css-extract-rspack-plugin
export default {"error":"flAHRtBIAI8TIDZi","tableContainer":"AXOFOcRckLsmd3va","emptyStateContainer":"js9nZfQWWeY36dEq","emptyStateText":"BU3ZLU2zzxkBN5M4","errorContainer":"keuFvFfDeQ4XjN30"};